import { Stack } from "@chakra-ui/react";
import React, { memo, useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeData, NodeType } from "../../../models/nodeType";
import SelectMusic from "../../base/SelectMusic";
import { FlowNodeWithChildren } from "./FlowNode";

interface PrefetchMusic extends NodeData {
  fileName: string;
}

const PrefetchMusicNode: React.FC<NodeProps<NodeType<PrefetchMusic>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const fileName = nodeData?.fileName ?? "";

  const { register, getValues, setValue, handleSubmit } = useForm<PrefetchMusic>({
    defaultValues: useMemo(
      () => ({
        fileName,
      }),
      [fileName]
    ),
    mode: "onChange",
  });

  const { updateNodeData } = useUpdateNodeData<PrefetchMusic>(nodeId);

  const handleUpdate = useCallback(
    (nodeData: PrefetchMusic) => {
      updateNodeData(nodeData);
    },
    [updateNodeData]
  );

  return (
    <>
      <FlowNodeWithChildren {...props}>
        <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
          <Stack>
            <SelectMusic
              value={getValues("fileName")}
              setValue={(value) => setValue("fileName", value)}
              color={color}
            />
          </Stack>
        </form>
      </FlowNodeWithChildren>
    </>
  );
};

export default memo(PrefetchMusicNode);
